// third-party
import { Trans } from 'react-i18next';

// assets
import { IconBuildingStore, IconUsers, IconBinaryTree, IconTruck } from '@tabler/icons';
import { OverrideIcon } from 'types';

// constant
const icons = {
    IconBuildingStore,
    IconBinaryTree,
    IconUsers,
    IconTruck,
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

interface SystemMenuProps {
    id: string;
    title: React.ReactNode | string;
    type: string;
    children?: {
        id: string;
        title: React.ReactNode | string;
        type: string;
        url: string;
        icon: OverrideIcon;
        breadcrumbs: boolean;
    }[];
}
const system: SystemMenuProps = {
    id: 'system',
    title: <Trans i18nKey="system" id="system" />,
    type: 'group',
    children: [
        {
            id: 'stores',
            title: <Trans i18nKey="Stores" id="Stores" />,
            type: 'item',
            url: '/stores',
            icon: icons.IconBuildingStore,
            breadcrumbs: false,
        },
        {
            id: 'users',
            title: <Trans i18nKey="Users" id="Users" />,
            type: 'item',
            url: '/users',
            icon: icons.IconUsers,
            breadcrumbs: false
        },
        {
            id: 'departments',
            title: <Trans i18nKey="Departments" id="Departments" />,
            type: 'item',
            url: '/departments',
            icon: icons.IconBinaryTree,
            breadcrumbs: false
        },
        {
            id: 'shippers',
            title: <Trans i18nKey="Shippers" id="Shippers" />,
            type: 'item',
            url: '/shippers',
            icon: icons.IconTruck,
            breadcrumbs: false
        },
    ]
};

export default system;
